import { twMerge } from 'tailwind-merge';
import { type ButtonHTMLAttributes, useEffect, useState } from 'react';

export interface ToggleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isChecked?: boolean;
  onToggle?: (checked: boolean) => void;
  id?: string;
  labelTrue?: string;
  labelFalse?: string;
  className?: string;
}

export const ToggleButton = ({
  isChecked = false,
  onToggle,
  id,
  labelTrue,
  labelFalse,
  className,
  ...props
}: ToggleButtonProps): JSX.Element => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleToggle = (): void => {
    const newChecked = !checked;
    setChecked(newChecked);
    if (onToggle) {
      onToggle(newChecked);
    }
  };

  return (
    <button
      id={id}
      type="button"
      className={twMerge('relative inline-flex h-5 w-10 cursor-pointer rounded-full', className)}
      onClick={handleToggle}
      {...props}
    >
      <div
        className={twMerge(
          'flex w-1/2 items-center justify-center rounded-l-full',
          checked ? 'bg-primary-600 text-white' : 'bg-greyscale-500',
        )}
      >
        <span>{labelTrue}</span>
      </div>
      <div
        className={twMerge(
          'flex w-1/2 items-center justify-center rounded-r-full',
          checked ? 'bg-greyscale-500' : 'bg-primary-600 text-white',
        )}
      >
        <span>{labelFalse}</span>
      </div>
    </button>
  );
};

ToggleButton.displayName = 'ToggleButton';
